<template>
    <div class="six">
      <slot />
    </div>
  </template>
  
  <script>
  export default {
    name: 'Six'
  }
  </script>
  
  <style scoped>
  .six {
    grid-column: span 6;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/importables/Six.vue